import _extends from "@babel/runtime/helpers/esm/extends";

/* eslint-disable import/order */
// This file has been generated using @svgr/cli.
// Run "yarn generate:icons" in order to generate the files for new icons.
import * as React from 'react';
import styled from 'styled-components';
import { size, color } from 'styled-system';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45 22.35a1.05 1.05 0 1 1-2.1 0c0-8.699-7.051-15.75-15.75-15.75a1.05 1.05 0 1 1 0-2.1C37.008 4.5 45 12.492 45 22.35Zm-7.979 21.2c-2.223 1.213-4.867 1.669-7.64 1.353-3.223-.367-6.547-1.66-9.835-3.775-2.269-1.459-4.366-3.175-6.12-5.007-3.294-3.166-5.868-6.856-7.413-10.682-1.81-4.48-2.029-8.633-.479-12.126.945-2.13 2.506-3.877 5.137-5.891.072-.06.072-.06.207-.178.733-.638 1.13-.896 1.751-1.09.787-.247 1.628-.193 2.417.136 1.11.462 2.075 1.322 3.028 2.613.617.835 1.102 1.737 1.693 3.107l.066.152.068.157c.68 1.567.906 2.364.913 3.425.01 1.252-.445 2.317-1.36 3.269l-.355.365h-.001c-.698.712-.952.993-1.215 1.342-.954 1.265-1.504 2.886-1.544 4.55-.05 2.043.794 4.214 2.17 5.66 2.452 2.337 6.416 2.957 9.247 1.449.574-.307 1.138-.753 1.735-1.378.08-.082.162-.173.297-.327l.121-.137c.54-.614.848-.914 1.274-1.217 1.08-.768 2.374-.956 3.827-.633.731.162 1.455.433 2.401.883.19.09.362.174.77.375 1.296.635 2.356 1.336 3.251 2.167 1.517 1.407 2.162 2.523 2.057 3.978-.065.93-.385 1.54-1.209 2.492l-.08.094c-.66.903-1.29 1.614-2.479 2.81-.853.86-1.74 1.541-2.7 2.064Zm.629-20.15c.58 0 1.05-.47 1.05-1.05 0-6.379-5.171-11.55-11.55-11.55a1.05 1.05 0 1 0 0 2.1 9.45 9.45 0 0 1 9.45 9.45c0 .58.47 1.05 1.05 1.05Z",
    fill: "currentColor"
  }));
};

var SvgRinging = styled(SvgComponent).withConfig({
  displayName: "Ringing__SvgRinging",
  componentId: "sc-1f9wsqm-0"
})(["", " ", ""], size, color);
export default SvgRinging;